import { render, staticRenderFns } from "./matching-list-mobile.vue?vue&type=template&id=7612550f&scoped=true&"
import script from "./matching-list-mobile.vue?vue&type=script&lang=ts&"
export * from "./matching-list-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./matching-list-mobile.vue?vue&type=style&index=0&id=7612550f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7612550f",
  null
  
)

export default component.exports